import AnnouncementDark from "./Dark/AnnouncementDark";
import AwardDark from "./Dark/AwardDark";
import BirthdayDark from "./Dark/BirthdayDark";
import WhatsHappeningDark from "./Dark/WhatsHappeningDark";
import AnnouncementLight from "./Light/AnnouncementLight";
import AwardLight from "./Light/AwardLight";
import BirthdayLight from "./Light/BirthdayLight";
import WhatsHappeningLight from "./Light/WhatsHappeningLight";
import ApprovalState from "./States/ApprovalState";
import AwardState from "./States/AwardState";
import BagState from "./States/BagState";
import CakeState from "./States/CakeState";
import CalanderState from "./States/CalanderState";
import CameraState from "./States/CameraState";
import ConnectionState from "./States/ConnectionState";
import DateState from "./States/DateState";
import DocumentState from "./States/DocumentState";
import ErrorState from "./States/ErrorState";
import FireState from "./States/FireState";
import GenderState from "./States/GenderState";
import HiddenState from "./States/HiddenState";
import LeaveState from "./States/LeaveState";
import ListState from "./States/ListState";
import MegaPhoneState from "./States/MegaPhoneState";
import NoteState from "./States/NoteState";
import ProfileState from "./States/ProfileState";
import QuestionMarkState from "./States/QuestionMarkState";
import StatesState from "./States/StatsState";
import TimeState from "./States/TimeState";
export const MoreEmptyStatesData = [
  {
    id: "CameraState",
    label: "Camera",
    text: "Text Goes here",
    code: "<CameraState/>",
    emptyState: CameraState,
  },
  {
    id: "ConnectionState",
    label: "Connection",
    text: "Text Goes here",
    code: "<ConnectionState />",
    emptyState: ConnectionState,
  },
  {
    id: "ErrorState",
    label: "Error",
    text: "Text Goes here",
    code: "<ErrorState />",
    emptyState: ErrorState,
  },
  {
    id: "QuestionMarkState",
    label: "QuestionMark",
    text: "Text Goes here",
    code: "<QuestionMarkState />",
    emptyState: QuestionMarkState,
  },
  {
    id: "TimeState",
    label: "Time",
    text: "Text Goes here",
    code: "<TimeState />",
    emptyState: TimeState,
  },
  {
    id: "GenderState",
    label: "Gender",
    text: "Text Goes here",
    code: "<GenderState />",
    emptyState: GenderState,
  },
  {
    id: "ListState",
    label: "List",
    text: "Text Goes here",
    code: "<ListState />",
    emptyState: ListState,
  },
  {
    id: "CalanderState",
    label: "Calander",
    text: "Text Goes here",
    code: "<CalanderState />",
    emptyState: CalanderState,
  },
  {
    id: "LeaveState",
    label: "Leave",
    text: "Text Goes here",
    code: "<LeaveState />",
    emptyState: LeaveState,
  },
  {
    id: "NoteState",
    label: "Note",
    text: "Text Goes here",
    code: "<NoteState />",
    emptyState: NoteState,
  },
  {
    id: "HiddenState",
    label: "Hidden",
    text: "Text Goes here",
    code: "<HiddenState />",
    emptyState: HiddenState,
  },
  {
    id: "StatesState",
    label: "States",
    text: "Text Goes here",
    code: "<StatesState />",
    emptyState: StatesState,
  },
  {
    id: "DocumentState",
    label: "Document",
    text: "Text Goes here",
    code: "<DocumentState />",
    emptyState: DocumentState,
  },
  {
    id: "AwardState",
    label: "Award",
    text: "Text Goes here",
    code: "<AwardState />",
    emptyState: AwardState,
  },
  {
    id: "FireState",
    label: "Fire",
    text: "Text Goes here",
    code: "<FireState />",
    emptyState: FireState,
  },
  {
    id: "DateState",
    label: "Date",
    text: "Text Goes here",
    code: "<DateState />",
    emptyState: DateState,
  },
  {
    id: "ApprovalState",
    label: "Approval",
    text: "Text Goes here",
    code: "<ApprovalState />",
    emptyState: ApprovalState,
  },
  {
    id: "ProfileState",
    label: "Profile",
    text: "Text Goes here",
    code: "<ProfileState />",
    emptyState: ProfileState,
  },
  {
    id: "MegaPhoneState",
    label: "MegaPhone",
    text: "Text Goes here",
    code: "<MegaPhoneState />",
    emptyState: MegaPhoneState,
  },
  {
    id: "CakeState",
    label: "Cake",
    text: "Text Goes here",
    code: "<CakeState />",
    emptyState: CakeState,
  },
  {
    id: "BagState",
    label: "Bag",
    text: "Text Goes here",
    code: "<BagState />",
    emptyState: BagState,
  },
];
export const MoreEmptyStatesDarkData = [
  {
    id: "announcement",
    label: "Announcement",
    text: "Text Goes here",
    code: "<AnnouncementDark />",
    emptyState: AnnouncementDark,
  },
  {
    id: "awardDark",
    label: "Award ",
    text: "Text Goes here",
    code: "<AwardDark/>",
    emptyState: AwardDark,
  },
  {
    id: "whatsHappeningDark",
    label: "Whats Happening ",
    text: "Text Goes here",
    code: "<WhatsHappeningDark/>",
    emptyState: WhatsHappeningDark,
  },
  {
    id: "birthdayDark",
    label: "Whats Happening ",
    text: "Text Goes here",
    code: "<BirthdayDark/>",
    emptyState: BirthdayDark,
  },
];

export const MoreEmptyStatesLightData = [
  {
    id: "announcement",
    label: "Announcement",
    text: "Text Goes here",
    code: "<AnnouncementLight />",
    emptyState: AnnouncementLight,
  },
  {
    id: "awardLight",
    label: "Award ",
    text: "Text Goes here",
    code: "<AwardLight/>",
    emptyState: AwardLight,
  },
  {
    id: "whatsHappeningLight",
    label: "Whats Happening ",
    text: "Text Goes here",
    code: "<WhatsHappeningLight/>",
    emptyState: WhatsHappeningLight,
  },
  {
    id: "birthdayLight",
    label: "Whats Happening ",
    text: "Text Goes here",
    code: "<BirthdayLight/>",
    emptyState: BirthdayLight,
  },
  //   {
  //     id: "birthday",
  //     label: "Birthday",
  //     text: "Text Goes here",
  //     code: "<LightBirthday />",
  //     emptyState: LightBirthday,
  //   },
  //   {
  //     id: "leave-request",
  //     label: "Leave Request",
  //     text: "Text Goes here",
  //     code: "<LightLeaveRequest />",
  //     emptyState: LightLeaveRequest,
  //   },
  //   {
  //     id: "payroll",
  //     label: "Payroll",
  //     text: "Text Goes here",
  //     code: "<LightPayroll />",
  //     emptyState: LightPayroll,
  //   },
  //   {
  //     id: "team",
  //     label: "Team",
  //     text: "Text Goes here",
  //     code: "<LightTeam />",
  //     emptyState: LightTeam,
  //   },
  //   {
  //     id: "upcoming-leaves",
  //     label: "Upcoming Leaves",
  //     text: "Text Goes here",
  //     code: "<LightUpcomingLeaves />",
  //     emptyState: LightUpcomingLeaves,
  //   },
  //   {
  //     id: "whats-happening",
  //     label: "What's Happening",
  //     text: "Text Goes here",
  //     code: "<LightWhatsHappening />",
  //     emptyState: LightWhatsHappening,
  //   },
  //   {
  //     id: "work-anniversary",
  //     label: "Work Anniversary",
  //     text: "Text Goes here",
  //     code: "<LightWorkAnniv />",
  //     emptyState: LightWorkAnniv,
  //   },
];
